<template>
  <section ref="boxRef" :class="getClass">
    <div> <slot></slot> </div>
  </section>
</template>

<script setup lang="ts">
  import { computed, ref, unref } from 'vue';
  import { useDesign } from '/@/hooks/web/useDesign';
  import { useElementBounding } from '@vueuse/core';
  const props = defineProps<{
    active?: boolean;
  }>();
  const HEIGHT = 42;
  const WIDTH = 500;
  const SCALE = 0.2;
  const BORDER_WIDTH = 100;
  const SLICE = 21;
  const { prefixCls } = useDesign('step-start');
  console.log('prefixCls', prefixCls);
  const boxRef = ref<HTMLElement | null>(null);
  const { height } = useElementBounding(boxRef);
  const width = computed(() => {
    return WIDTH * (unref(height) / HEIGHT) + '%';
  });
  const scale = computed(() => {
    return SCALE * (HEIGHT / unref(height));
  });
  const borderWidth = computed(() => {
    return BORDER_WIDTH + (unref(height) - HEIGHT) * 5 + 'px';
  });
  const getClass = computed(() => {
    return {
      [`${prefixCls}`]: true,
      actived: props.active,
    };
  });
</script>

<style lang="less">
  @step: 'start';
  @prefix-cls: ~'@{namespace}-step-@{step}';
  .imgSlice() {
    border-image-slice: v-bind(SLICE);
    border-image-repeat: stretch;
  }
  .@{prefix-cls} {
    position: relative;
    padding: 10px 10px 10px 20px;

    // 超出部分显示省略号
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &::before {
      content: ' ';
      // 背景图片横向拉伸填充 纵向保持不变
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      border: v-bind(borderWidth) solid var(--component-bg-color);
      border-image: url('/@/assets/svg/progress/@{step}.svg');
      border-image-slice: v-bind(SLICE);
      border-image-repeat: stretch;
      width: v-bind(width);
      height: v-bind(width);
      transform: scale(v-bind(scale));
      transform-origin: 0 0;
    }

    & > div {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
    }

    &:hover {
      &::before {
        border-image: url('/@/assets/svg/progress/@{step}-active.svg');
        .imgSlice();
      }
    }

    &.actived {
      &::before {
        border-image: url('/@/assets/svg/progress/@{step}_fill-active.svg');
        .imgSlice();
      }

      & > div {
        background: var(--primary-color-2);
      }
    }
  }
</style>
